<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
              <form @submit.prevent="logMeIn">
                <h1>Login</h1>
                <p class="text-muted">Log In to your account</p>
                <b-input-group class="mb-3">
                  <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                  <input type="text" class="form-control" placeholder="Username" v-model="credentials.username" required>
                </b-input-group>
                <b-input-group class="mb-4">
                  <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                  <input type="password" class="form-control" placeholder="Password" v-model="credentials.password" required>
                </b-input-group>
                <b-row>
                    <b-col cols="6">
                        <b-col cols="6">
                          <b-form-checkbox id="checkbox1" v-model="rememberMe" plain>
                            Remember Me
                          </b-form-checkbox>
                        </b-col>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="success" class="px-4" type="submit">Login</b-button>
                  </b-col>
                </b-row>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {apiLogin, apiAcl, authUser, authACL, authAccessToken} from '../functions/common.vue'
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      loggingIn: false,
      error: '',
      rememberMe:false
    }
  },
  mounted: function()
  {
    let email = document.cookie.match('(^|;)\\s*' + 'email' + '\\s*=\\s*([^;]+)')
    let password = document.cookie.match('(^|;)\\s*' + 'password' + '\\s*=\\s*([^;]+)')
      
    this.credentials.username = email ? email.pop() : ''
    this.credentials.password = password ? password.pop() : ''
  },
  methods: {
    logMeIn () {
      let email = this.credentials.username.trim()
      let password = this.credentials.password.trim()

      localStorage.clear()        
      if(this.rememberMe)
        {
          let d = new Date()
          d.setTime(d.getTime() + (180*24*60*60*1000))
          console.log(d)
          document.cookie = 'email=' + email + ';expires=' + d.toUTCString() + ':path=/'
          document.cookie = 'password='+password+';expires='+ d.toUTCString() + ':path=/'
        } 
        else
        {
          document.cookie = 'email=; expires= Thu, 01 Jan 1970 00:00:00: UTC; path=/;'
          document.cookie = 'password=; expires= Thu, 01 Jan 1970 00:00:00: UTC; path=/;'
        }
        
      axios.post(apiLogin, {
        userId: email,
        password: password
      })
      .then (res => {
        if (res.data.data.access_token)
        {
          localStorage.access_token = res.data.data.access_token
          localStorage.auth_acl = res.data.data.acl
          location.reload()
          this.$router.push('/dashboard')
        }
        else
        {
          this.$router.push('/login')
        }
      })
      .catch(error => alert(error))
    }
  }
}
</script>
<style>
  .error {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue